/*
 * Structured error type shared by the tool registry and every transport.
 *
 * Agents reason better about a stable machine-readable `code` than about prose,
 * so every failure that leaves the registry carries one.
 */

export const ErrorCode = {
  TOOL_NOT_FOUND: 'TOOL_NOT_FOUND',
  INVALID_ARGUMENTS: 'INVALID_ARGUMENTS',
  TOOL_ERROR: 'TOOL_ERROR',
  NOT_SUPPORTED: 'NOT_SUPPORTED',
  PRECONDITION_FAILED: 'PRECONDITION_FAILED',
  // Editor-specific, so an agent can branch on the cause instead of parsing prose.
  EDITOR_NOT_READY: 'EDITOR_NOT_READY',
  LAYER_NOT_FOUND: 'LAYER_NOT_FOUND',
  UNSUPPORTED_LAYER_TYPE: 'UNSUPPORTED_LAYER_TYPE',
  REVISION_MISMATCH: 'REVISION_MISMATCH',
  NOTHING_TO_UNDO: 'NOTHING_TO_UNDO',
  NOTHING_TO_REDO: 'NOTHING_TO_REDO'
}

export class ToolError extends Error {
  /**
   * @param {string} code one of ErrorCode
   * @param {string} message human + agent readable, must not leak secrets
   * @param {object} [details] structured extra context (field paths, valid values, ...)
   */
  constructor (code, message, details) {
    super(message)
    this.name = 'ToolError'
    this.code = code
    this.details = details
  }

  toJSON () {
    return { code: this.code, message: this.message, ...(this.details ? { details: this.details } : {}) }
  }
}

/** Turn anything thrown by a tool handler into a serializable error object. */
export function toErrorPayload (err) {
  if (err instanceof ToolError) return err.toJSON()
  return { code: ErrorCode.TOOL_ERROR, message: err && err.message ? err.message : String(err) }
}
